import api from '@common/api';
import { WaitListShortContactInfo } from '@services/appsync/types';
import { createStore, useStore } from 'zustand';
import { persist } from 'zustand/middleware';

interface WaitlistModelProps {
  waitlistPosition?: WaitListShortContactInfo;
}
interface WaitlistModelActions {
  fetchWaitlistPosition: (email: string) => Promise<WaitListShortContactInfo | null>;
}

export const WaitlistModel = createStore(
  persist<WaitlistModelProps & WaitlistModelActions>(
    (set) => ({
      fetchWaitlistPosition: async (email) => {
        const waitlistPosition = await api.waitlistLookupEmail({ email });
        if (waitlistPosition) set({ waitlistPosition });
        return waitlistPosition ? waitlistPosition : null;
      },
    }),
    {
      getStorage: () => localStorage,
      name: 'waitlist-model',
    },
  ),
);

export function useWaitlistModel(): WaitlistModelProps & WaitlistModelActions;
export function useWaitlistModel<T>(
  selector: (state: WaitlistModelProps & WaitlistModelActions) => T,
  equals?: (a: T, b: T) => boolean,
): T;
export function useWaitlistModel<T>(
  selector?: (state: WaitlistModelProps & WaitlistModelActions) => T,
  equals?: (a: T, b: T) => boolean,
) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return useStore(WaitlistModel, selector!, equals);
}
